import Vue from 'vue'
import vuetify from './plugins/vuetify';
import store from './store'

import formatDate from './filters/dateFormat';
import formatFilter from "@/filters/filterFormat";

import Index from "./Index";

import router from './router'
import * as axios from "axios";
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'highlight.js/styles/github.css';

import hljs from 'highlight.js/lib/highlight';
import xml from 'highlight.js/lib/languages/xml';
import json from 'highlight.js/lib/languages/json';
import plaintext from 'highlight.js/lib/languages/plaintext';
import moment from "moment";
import {REFERENTIEL_NS} from "@/store/modules/referentiel";

hljs.registerLanguage('xml', xml);
hljs.registerLanguage('json', json);
hljs.registerLanguage('plaintext', plaintext);

// ISO-8601, Europe
moment.updateLocale("en", {
  week: {
    dow: 1, // First day of week is Monday
    doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
  }
});

Vue.config.productionTip = false;

axios.interceptors.response.use();

Vue.filter('formatDate', formatDate);
Vue.filter('formatFilter', formatFilter);

new Vue({
  vuetify,
  render: h => h(Index),
  store,
  router,
  components: { Index },
  created() {
    this.$store.dispatch(`${REFERENTIEL_NS}/initReferentiel`);
  }
}).$mount('#app');
